import { useTranslation } from 'react-i18next';

import { InfoModal } from 'components/InfoModal';
import { Tabs } from 'components/Tabs';

import { useDetails } from './Details.hooks';
import * as S from './Details.styles';
import { Header } from './components/Header';

export function Details(): React.ReactElement {
  // isLoading / budgetStatus are only used by the hidden Send button below
  const { tabs, isModalVisible, isModalVisibleSet, sendBudget } = useDetails();
  const { t } = useTranslation();

  return (
    <>
      <Header />

      <S.Wrapper>
        {/* Send Budget button hidden for now; to bring it back, uncomment it and
            take isLoading and budgetStatus from useDetails() again.
        {budgetStatus?.toLocaleLowerCase() === 'to send' ? (
          <S.SendButton
            scale="xs"
            fontFamily="LFT Zeno"
            motive="actionSecondary"
            iconLeft="FiChevronRight"
            onClick={() => isModalVisibleSet(true)}
            isLoading={isLoading}
          >
            {t('budget.sendBudget')}
          </S.SendButton>
        ) : undefined}
        */}

        <Tabs tabs={tabs} keepVisitedMounted />

        {isModalVisible ? (
          <InfoModal
            title={t('common.warning')}
            info={t('budget.confirmSend')}
            actionText={t('budget.yesSend')}
            onAction={() => sendBudget()}
            onClose={() => isModalVisibleSet(false)}
          />
        ) : undefined}
      </S.Wrapper>
    </>
  );
}
